import StatusesSpamRoute from "./StatusesSpamRoute";

export default StatusesSpamRoute